// extracted by mini-css-extract-plugin
module.exports = {"building-link":"c6e8ba5398--building-link--2jLxs"};